var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c("div", { staticClass: "onlyForHighScreens" }, [_vm._v(" ")]),
      !_vm.ready
        ? _c(
            "div",
            [
              _c("div", { staticClass: "spacer-25" }),
              _c("v-skeleton-loader", {
                staticClass: "mx-auto",
                attrs: { "max-width": "600", type: "card" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.ready
        ? _c("v-container", { attrs: { "grid-list-md": "" } }, [
            _vm.order.stornoAmounts && _vm.order.stornoAmounts.length > 0
              ? _c("div", { staticClass: "mt-5 mb-5" }, [
                  _c(
                    "div",
                    {
                      staticClass: "pa-3",
                      staticStyle: {
                        "background-color": "#333333",
                        color: "#DDDD00",
                      },
                    },
                    [
                      _c("div", [_vm._v("Bereits stornierte Artikel:")]),
                      _vm._l(_vm.order.stornoAmounts, function (sa) {
                        return _c("div", { staticClass: "mt-2" }, [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("div", { staticClass: "pr-3" }, [
                              _vm._v(
                                "-" +
                                  _vm._s(sa.countRemoved) +
                                  " x " +
                                  _vm._s(sa.name)
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "flex-grow-1 text-right" },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("price")(sa.amountRemoved))
                                ),
                              ]
                            ),
                          ]),
                        ])
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm.order.storno
              ? _c(
                  "div",
                  { staticClass: "pickupHint text-center" },
                  [
                    _c("h3", { staticClass: "mt-4" }, [
                      _vm._v("Die Bestellung wurde storniert"),
                    ]),
                    _c("div", [
                      _c("b", [
                        _vm._v(
                          "Bestellnummer: #" + _vm._s(_vm.order.orderNumber)
                        ),
                      ]),
                    ]),
                    _vm.order.userInfo && _vm.order.userInfo.name
                      ? _c("div", [
                          _c("b", [
                            _vm._v("Name: " + _vm._s(_vm.order.userInfo.name)),
                          ]),
                        ])
                      : _vm._e(),
                    !_vm.$store.getters.isKiosk
                      ? _c("div", [_vm._v("Zahlung: storniert")])
                      : _vm._e(),
                    _c("div", { staticClass: "spacer-25" }),
                    _c("ItemDetails", { attrs: { order: _vm.order } }),
                    _vm.order.note && _vm.order.note.length > 0
                      ? _c("div", { staticClass: "mt-5" }, [
                          _c("div", [
                            _vm._v("Hinweis: " + _vm._s(_vm.order.note)),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _c("div", [
                  _vm.order.usecase === "takeAway" ||
                  _vm.order.usecase === "delivery" ||
                  _vm.order.usecase === "digital"
                    ? _c(
                        "div",
                        {
                          staticClass: "pickupHint text-center",
                          style: { opacity: _vm.order.sentToPos ? "1" : "0.8" },
                        },
                        [
                          _c("div", { staticClass: "text-center pt-5 mb-5" }, [
                            (!_vm.dynamicSelfServiceEnabled ||
                              _vm.order.usecase === "delivery" ||
                              _vm.order.usecase === "takeAway" ||
                              _vm.order.usecase === "digital") &&
                            (!_vm.withPosApi || _vm.order.sentToPos)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "icon icon--order-success svg",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "72",
                                          height: "72",
                                          viewBox: "0 0 72 72",
                                        },
                                      },
                                      [
                                        _c("circle", {
                                          attrs: {
                                            stroke: "#50A92F",
                                            "stroke-width": "2",
                                            cx: "36",
                                            cy: "36",
                                            r: "34",
                                            fill: "none",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            "fill-rule": "evenodd",
                                            "clip-rule": "evenodd",
                                            fill: "#50A92F",
                                            d: "M52.5 21.4c-.9-.6-2.1-.5-2.8.2l-20.7 20.2-4.7-5.1c-.8-.8-2.4-1.2-3.5-.5-1.1.9-1.2 2.3-.5 3.5 0 0 5.1 8.7 5.7 9.7s1.6 1.6 3 1.6c1.1 0 2-.6 2.9-1.6.7-.8 20.8-25.3 20.8-25.3.6-.7.6-2-.2-2.7z",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "confirmed",
                              staticStyle: { margin: "15px 0" },
                            },
                            [
                              _vm.order.usecase === "takeAway" ||
                              _vm.order.usecase === "digital"
                                ? _c(
                                    "div",
                                    [
                                      _vm.$store.getters.isKiosk
                                        ? [
                                            _c("h1", [
                                              _vm._v(
                                                " Abholnummer: " +
                                                  _vm._s(
                                                    _vm.order.orderNumber
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _vm.order.userInfo?.name
                                              ? _c(
                                                  "h2",
                                                  { staticClass: "mb-10" },
                                                  [
                                                    _vm._v(
                                                      "Name: " +
                                                        _vm._s(
                                                          _vm.order.userInfo
                                                            .name
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : [
                                            _vm.dynamicSelfServiceEnabled &&
                                            _vm.isTakeawayForNow
                                              ? _c("div", [
                                                  _c("h3", [
                                                    _vm._v(
                                                      "Summe: " +
                                                        _vm._s(
                                                          _vm._f("price")(
                                                            _vm.order
                                                              .paymentInfo
                                                              .amount
                                                          )
                                                        )
                                                    ),
                                                  ]),
                                                  _c("h3", [
                                                    _vm._v(
                                                      "Bestell-Nr: " +
                                                        _vm._s(
                                                          _vm.order.orderNumber
                                                        )
                                                    ),
                                                  ]),
                                                  _vm.order.usecase !==
                                                  "digital"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-left d-inline-block mt-2",
                                                            },
                                                            [
                                                              _c("div", [
                                                                _c(
                                                                  "b",
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "iconOk",
                                                                        attrs: {
                                                                          medium:
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-check-bold"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " Bestellung übermittelt"
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c(
                                                                  "b",
                                                                  [
                                                                    _vm.isInZubereitung
                                                                      ? _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "iconOk",
                                                                            attrs:
                                                                              {
                                                                                medium:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-check-bold "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "iconNotOk",
                                                                            attrs:
                                                                              {
                                                                                medium:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-close-thick"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                    _vm._v(
                                                                      "  In Zubereitung"
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]),
                                                              _vm.hasGetraenke()
                                                                ? _c("div", [
                                                                    _c(
                                                                      "b",
                                                                      [
                                                                        _vm
                                                                          .order
                                                                          .getraenkeAbholbereit
                                                                          ? _c(
                                                                              "v-icon",
                                                                              {
                                                                                staticClass:
                                                                                  "iconOk",
                                                                                attrs:
                                                                                  {
                                                                                    medium:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-check-bold "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "v-icon",
                                                                              {
                                                                                staticClass:
                                                                                  "iconNotOk",
                                                                                attrs:
                                                                                  {
                                                                                    medium:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-close-thick"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                        _vm._v(
                                                                          "  Getränke abholbereit"
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              _vm.hasSpeisen()
                                                                ? _c("div", [
                                                                    _c(
                                                                      "b",
                                                                      [
                                                                        _vm
                                                                          .order
                                                                          .abholbereit
                                                                          ? _c(
                                                                              "v-icon",
                                                                              {
                                                                                staticClass:
                                                                                  "iconOk",
                                                                                attrs:
                                                                                  {
                                                                                    medium:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-check-bold "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "v-icon",
                                                                              {
                                                                                staticClass:
                                                                                  "iconNotOk",
                                                                                attrs:
                                                                                  {
                                                                                    medium:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-close-thick"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                        _vm._v(
                                                                          "  Abholbereit"
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              _c("div", [
                                                                _c(
                                                                  "b",
                                                                  [
                                                                    _vm.isPickedUp
                                                                      ? _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "iconOk",
                                                                            attrs:
                                                                              {
                                                                                medium:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-check-bold "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "iconNotOk",
                                                                            attrs:
                                                                              {
                                                                                medium:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-close-thick"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                    _vm._v(
                                                                      "  Abgeholt"
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          !_vm.order.abholbereit
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mt-2",
                                                                  staticStyle: {
                                                                    opacity:
                                                                      "0.8",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Der Status aktualisiert automatisch "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ])
                                              : _c("div", [
                                                  _vm.showVorbestellung &&
                                                  !_vm.containsTicket()
                                                    ? _c("h3", [
                                                        _vm._v(
                                                          "Vorbestellung für " +
                                                            _vm._s(
                                                              _vm._f("sdd")(
                                                                _vm.computedPickupTime
                                                              )
                                                            ) +
                                                            " Uhr"
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.posConfirmed ||
                                                  _vm.isInZubereitung
                                                    ? _c("div", [
                                                        _vm._v(
                                                          "(bestätigte Abholzeit)"
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    { staticClass: "mt-2" },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Bestell-Nr: #" +
                                                            _vm._s(
                                                              _vm.order
                                                                .orderNumber
                                                            )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm.order.userInfo?.name
                                                    ? _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Name: " +
                                                              _vm._s(
                                                                _vm.order
                                                                  .userInfo.name
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _vm._e(),
                                                  !_vm.$store.getters.isKiosk &&
                                                  _vm.displayZahlungsart
                                                    ? _c("div", [
                                                        _vm._v(
                                                          "Zahlungart: " +
                                                            _vm._s(
                                                              _vm.displayZahlungsart
                                                            )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  !_vm.$store.getters.isKiosk
                                                    ? _c("div", [
                                                        _vm._v("Abbuchung: "),
                                                        _vm.order.capturedAt
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "am " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "sdd"
                                                                    )(
                                                                      _vm.order
                                                                        .capturedAt
                                                                    )
                                                                  ) +
                                                                  " Uhr"
                                                              ),
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                "ausstehend"
                                                              ),
                                                            ]),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.containsTicket() &&
                                                  _vm.order.userInfo
                                                    ? _c(
                                                        "div",
                                                        { staticClass: "pt-2" },
                                                        [
                                                          _vm._v(
                                                            " Du erhälst die Tickets in wenigen Sekunden in deinem Email-Postfach " +
                                                              _vm._s(
                                                                _vm.order
                                                                  .userInfo
                                                                  .email
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c("div", {
                                                    staticClass: "spacer-25",
                                                  }),
                                                ]),
                                          ],
                                      _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left d-inline-block mb-2",
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "b",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "iconOk",
                                                        attrs: { medium: "" },
                                                      },
                                                      [_vm._v("mdi-check-bold")]
                                                    ),
                                                    _vm._v(
                                                      "  Bestellung übermittelt"
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                              !_vm.$store.getters.isKiosk
                                                ? [
                                                    _c("div", [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm.posConfirmed ||
                                                          _vm.isInZubereitung
                                                            ? _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-check-bold "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconNotOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-close-thick"
                                                                  ),
                                                                ]
                                                              ),
                                                          _vm._v("  Bestätigt"),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm.isInZubereitung
                                                            ? _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-check-bold "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconNotOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-close-thick"
                                                                  ),
                                                                ]
                                                              ),
                                                          _vm._v(
                                                            "  In Zubereitung"
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm.isPickupReady
                                                            ? _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-check-bold "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconNotOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-close-thick"
                                                                  ),
                                                                ]
                                                              ),
                                                          _vm._v(
                                                            "  Abholbereit"
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm.isPickedUp
                                                            ? _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-check-bold "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconNotOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-close-thick"
                                                                  ),
                                                                ]
                                                              ),
                                                          _vm._v("  Abgeholt"),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.order.usecase === "delivery"
                                ? _c("div", [
                                    _c("h3", [
                                      _vm._v(
                                        "Lieferung für " +
                                          _vm._s(
                                            _vm._f("weekDayMonth")(
                                              _vm.computedDeliveryTime
                                            )
                                          ) +
                                          ", ca. " +
                                          _vm._s(
                                            _vm._f("uhrzeit")(
                                              _vm.computedDeliveryTime
                                            )
                                          ) +
                                          " Uhr"
                                      ),
                                    ]),
                                    _vm.order.posConfirmedTime
                                      ? _c("div", [
                                          _vm._v("(bestätigte Lieferzeit)"),
                                        ])
                                      : _vm._e(),
                                    _c("h3", [
                                      _vm._v(
                                        "Summe: " +
                                          _vm._s(
                                            _vm._f("price")(
                                              _vm.order.paymentInfo.amount
                                            )
                                          )
                                      ),
                                    ]),
                                    _c("h3", [
                                      _vm._v(
                                        "Bestell-Nr: " +
                                          _vm._s(_vm.order.orderNumber)
                                      ),
                                    ]),
                                    _c("div", { staticClass: "pt-4" }, [
                                      _vm._v(
                                        "Lieferadresse: " +
                                          _vm._s(
                                            _vm._f(
                                              "displayDeliveryAddressSingleLine"
                                            )(_vm.order.deliveryAddress)
                                          )
                                      ),
                                    ]),
                                    _vm.order.usecase !== "digital"
                                      ? _c(
                                          "div",
                                          { staticClass: "text-center" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-left d-inline-block mt-2",
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "b",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "iconOk",
                                                          attrs: { medium: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-check-bold"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " Bestellung übermittelt"
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c(
                                                    "b",
                                                    [
                                                      _vm.posConfirmed ||
                                                      _vm.isInZubereitung
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "iconOk",
                                                              attrs: {
                                                                medium: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-check-bold "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "iconNotOk",
                                                              attrs: {
                                                                medium: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close-thick"
                                                              ),
                                                            ]
                                                          ),
                                                      _vm._v("  Bestätigt"),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c(
                                                    "b",
                                                    [
                                                      _vm.isInZubereitung
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "iconOk",
                                                              attrs: {
                                                                medium: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-check-bold "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "iconNotOk",
                                                              attrs: {
                                                                medium: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close-thick"
                                                              ),
                                                            ]
                                                          ),
                                                      _vm._v(
                                                        "  In Zubereitung"
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c(
                                                    "b",
                                                    [
                                                      _vm.inDelivery
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "iconOk",
                                                              attrs: {
                                                                medium: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-check-bold "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "iconNotOk",
                                                              attrs: {
                                                                medium: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close-thick"
                                                              ),
                                                            ]
                                                          ),
                                                      _vm._v("  In Lieferung"),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c(
                                                    "b",
                                                    [
                                                      _vm.isDelivered
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "iconOk",
                                                              attrs: {
                                                                medium: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-check-bold "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "iconNotOk",
                                                              attrs: {
                                                                medium: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close-thick"
                                                              ),
                                                            ]
                                                          ),
                                                      _vm._v("  Geliefert"),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              !_vm.$store.getters.isKiosk &&
                              _vm.order.usecase === "takeAway" &&
                              !_vm.containsTicket()
                                ? _c("div", [
                                    _c("div", [
                                      _vm._v(
                                        "Abholort: " +
                                          _vm._s(
                                            _vm.$store.state
                                              .staticDisplayAbholung
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "spacer-15" }),
                            ]
                          ),
                          _c("ItemDetails", { attrs: { order: _vm.order } }),
                          _vm.order.note && _vm.order.note.length > 0
                            ? _c("div", { staticClass: "mt-5" }, [
                                _c("div", [
                                  _vm._v("Hinweis: " + _vm._s(_vm.order.note)),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.order.usecase === "tableOrdering" ||
                  _vm.order.usecase === "inhouseMobilePayment"
                    ? _c(
                        "div",
                        { staticClass: "pickupHint text-center" },
                        [
                          _vm.order.requiresPickupNotification &&
                          !_vm.$ls.get(_vm.getPickupKey()) &&
                          !_vm.order.abholbereit
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-4 pa-4 mb-4 hinweisBlink",
                                  staticStyle: {
                                    color: "yellow",
                                    "background-color": "black",
                                    opacity: "0.8",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.hh) + " ")]
                              )
                            : _c(
                                "div",
                                { staticClass: "text-center pt-4 mb-4" },
                                [
                                  !_vm.withPosApi || _vm.order.sentToPos
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "icon icon--order-success svg",
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "72",
                                                height: "72",
                                                viewBox: "0 0 72 72",
                                              },
                                            },
                                            [
                                              _c("circle", {
                                                attrs: {
                                                  stroke: "#50A92F",
                                                  "stroke-width": "2",
                                                  cx: "36",
                                                  cy: "36",
                                                  r: "34",
                                                  fill: "none",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  "fill-rule": "evenodd",
                                                  "clip-rule": "evenodd",
                                                  fill: "#50A92F",
                                                  d: "M52.5 21.4c-.9-.6-2.1-.5-2.8.2l-20.7 20.2-4.7-5.1c-.8-.8-2.4-1.2-3.5-.5-1.1.9-1.2 2.3-.5 3.5 0 0 5.1 8.7 5.7 9.7s1.6 1.6 3 1.6c1.1 0 2-.6 2.9-1.6.7-.8 20.8-25.3 20.8-25.3.6-.7.6-2-.2-2.7z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                          _c(
                            "div",
                            {
                              staticClass: "confirmed",
                              staticStyle: { margin: "15px 0" },
                            },
                            [
                              _c("div", { staticClass: "mb-2" }, [
                                _vm.$store.state.orderArea
                                  ? _c("div", [
                                      _c("h3", [
                                        _vm._v(
                                          "Bestellung für " +
                                            _vm._s(_vm.$store.state.orderArea)
                                        ),
                                      ]),
                                    ])
                                  : _c("div", [
                                      _vm.dynamicSelfServiceEnabled
                                        ? _c("div", [
                                            _vm.order.table
                                              ? _c("h3", [
                                                  _vm.order.ankunftszeitDate
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " Vorbestellung für 🍽️ Zum Hier essen mit geplanter Ankunftszeit am " +
                                                            _vm._s(
                                                              _vm.order
                                                                .ankunftszeitDate
                                                                .dayOfMonth
                                                            ) +
                                                            "." +
                                                            _vm._s(
                                                              _vm.order
                                                                .ankunftszeitDate
                                                                .month
                                                            ) +
                                                            ", "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-no-wrap",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.order
                                                                  .ankunftszeitDate
                                                                  .time
                                                              ) + " Uhr"
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          "Tisch " +
                                                            _vm._s(
                                                              _vm.order.table
                                                            )
                                                        ),
                                                      ]),
                                                ])
                                              : _vm._e(),
                                            _c("h4", [
                                              _vm._v(
                                                "Summe: " +
                                                  _vm._s(
                                                    _vm._f("price")(
                                                      _vm.order.paymentInfo
                                                        .amount
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _vm.computedPickupTime &&
                                            !_vm.containsTicket()
                                              ? _c(
                                                  "h4",
                                                  { staticClass: "mt-2" },
                                                  [
                                                    _vm._v(
                                                      "Abholung am " +
                                                        _vm._s(
                                                          _vm._f("sdd")(
                                                            _vm.computedPickupTime
                                                          )
                                                        ) +
                                                        " Uhr"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.posConfirmed ||
                                            _vm.isInZubereitung
                                              ? _c("div", [
                                                  _vm._v(
                                                    "(bestätigte Abholzeit)"
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.order.table
                                              ? _c("h4", [
                                                  _vm._v(
                                                    "Bestell-Nr: " +
                                                      _vm._s(
                                                        _vm.order.orderNumber
                                                      )
                                                  ),
                                                ])
                                              : _c("h4", [
                                                  _vm._v(
                                                    "Bestell-Nr: " +
                                                      _vm._s(
                                                        _vm.order.orderNumber
                                                      )
                                                  ),
                                                ]),
                                            _c(
                                              "div",
                                              { staticClass: "text-center" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-left d-inline-block mt-2",
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "b",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "iconOk",
                                                              attrs: {
                                                                medium: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-check-bold"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "  Bestellung übermittelt"
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm.posConfirmed ||
                                                          _vm.isInZubereitung
                                                            ? _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-check-bold "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconNotOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-close-thick"
                                                                  ),
                                                                ]
                                                              ),
                                                          _vm._v("  Bestätigt"),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm.isInZubereitung
                                                            ? _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-check-bold "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconNotOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-close-thick"
                                                                  ),
                                                                ]
                                                              ),
                                                          _vm._v(
                                                            "  In Zubereitung"
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                    _vm.hasGetraenke()
                                                      ? _c("div", [
                                                          _c(
                                                            "b",
                                                            [
                                                              _vm.order
                                                                .getraenkeAbholbereit
                                                                ? _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticClass:
                                                                        "iconOk",
                                                                      attrs: {
                                                                        medium:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-check-bold "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticClass:
                                                                        "iconNotOk",
                                                                      attrs: {
                                                                        medium:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-close-thick"
                                                                      ),
                                                                    ]
                                                                  ),
                                                              _vm._v(
                                                                "  Getränke abholbereit"
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.hasSpeisen()
                                                      ? _c("div", [
                                                          _c(
                                                            "b",
                                                            [
                                                              _vm.order
                                                                .abholbereit
                                                                ? _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticClass:
                                                                        "iconOk",
                                                                      attrs: {
                                                                        medium:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-check-bold "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticClass:
                                                                        "iconNotOk",
                                                                      attrs: {
                                                                        medium:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-close-thick"
                                                                      ),
                                                                    ]
                                                                  ),
                                                              _vm._v(
                                                                "  Abholbereit"
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _c("div", [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm.isPickedUp
                                                            ? _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-check-bold "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "iconNotOk",
                                                                  attrs: {
                                                                    medium: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-close-thick"
                                                                  ),
                                                                ]
                                                              ),
                                                          _vm._v("  Abgeholt"),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                !_vm.order.abholbereit
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "mt-2",
                                                        staticStyle: {
                                                          opacity: "0.8",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Der Status aktualisiert automatisch "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ])
                                        : _c(
                                            "div",
                                            [
                                              _vm.order.table &&
                                              !_vm.$store.getters.isKiosk
                                                ? _c("h3", [
                                                    _vm.order.ankunftszeitDate
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " Vorbestellung für 🍽️ Zum Hier essen mit geplanter Ankunftszeit am " +
                                                              _vm._s(
                                                                _vm.order
                                                                  .ankunftszeitDate
                                                                  .dayOfMonth
                                                              ) +
                                                              "." +
                                                              _vm._s(
                                                                _vm.order
                                                                  .ankunftszeitDate
                                                                  .month
                                                              ) +
                                                              ", "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-no-wrap",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.order
                                                                    .ankunftszeitDate
                                                                    .time
                                                                ) + " Uhr"
                                                              ),
                                                            ]
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            "Tisch " +
                                                              _vm._s(
                                                                _vm.order.table
                                                              )
                                                          ),
                                                        ]),
                                                  ])
                                                : _vm._e(),
                                              _vm.$store.getters.isKiosk
                                                ? [
                                                    _c("h1", [
                                                      _vm._v(
                                                        " Abholnummer: " +
                                                          _vm._s(
                                                            _vm.order
                                                              .orderNumber
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                    _vm.order.userInfo?.name
                                                      ? _c(
                                                          "h2",
                                                          {
                                                            staticClass:
                                                              "mb-10",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Name: " +
                                                                _vm._s(
                                                                  _vm.order
                                                                    .userInfo
                                                                    .name
                                                                )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                : [
                                                    _c("h3", [
                                                      _vm._v(
                                                        "Bestell-Nr: " +
                                                          _vm._s(
                                                            _vm.order
                                                              .orderNumber
                                                          )
                                                      ),
                                                    ]),
                                                    _c("h4", [
                                                      _vm._v(
                                                        "Summe: " +
                                                          _vm._s(
                                                            _vm._f("price")(
                                                              _vm.order
                                                                .paymentInfo
                                                                .amount
                                                            )
                                                          )
                                                      ),
                                                    ]),
                                                  ],
                                              _c(
                                                "div",
                                                { staticClass: "mt-4" },
                                                [
                                                  _c(
                                                    "b",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "iconOk",
                                                          attrs: { medium: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-check-bold"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " Bestellung übermittelt"
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              !_vm.$store.getters.isKiosk
                                                ? [
                                                    _vm.order.table &&
                                                    _vm.order.table !==
                                                      _vm.$store.state
                                                        .defaultInhouseTable
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt-2",
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v(
                                                                "Wir servieren deine Bestellung an deinen Tisch"
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt-2",
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v(
                                                                "Bestellung wird zubereitet"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                    ]),
                              ]),
                              !_vm.$store.getters.isKiosk &&
                              _vm.order.userInfo &&
                              _vm.order.userInfo.name
                                ? _c("div", [
                                    _c("b", [
                                      _vm._v(
                                        "Name: " +
                                          _vm._s(_vm.order.userInfo.name)
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              !_vm.$store.getters.isKiosk &&
                              _vm.displayZahlungsart
                                ? _c("div", [
                                    _vm._v(
                                      "Zahlungsart: " +
                                        _vm._s(_vm.displayZahlungsart)
                                    ),
                                  ])
                                : _vm._e(),
                              !_vm.$store.getters.isKiosk
                                ? _c("div", [
                                    _vm._v("Abbuchung: "),
                                    _vm.order.capturedAt
                                      ? _c("span", [
                                          _vm._v(
                                            "am " +
                                              _vm._s(
                                                _vm._f("sdd")(
                                                  _vm.order.capturedAt
                                                )
                                              ) +
                                              " Uhr"
                                          ),
                                        ])
                                      : _c("span", [_vm._v("ausstehend")]),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "spacer-15" }),
                              _vm.enableAllReady &&
                              !_vm.hideAllReadyBtn &&
                              !_vm.order.allReady
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-mini",
                                          nativeOn: {
                                            "&click": function ($event) {
                                              return _vm.clickFertig.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v("Wir sind fertig "),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("mdi-send")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "spacer-15" }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c("ItemDetails", { attrs: { order: _vm.order } }),
                          _vm.order.note && _vm.order.note.length > 0
                            ? _c("div", { staticClass: "mt-5" }, [
                                _c("div", [
                                  _vm._v("Hinweis: " + _vm._s(_vm.order.note)),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
            _vm.order.invoiceUrl
              ? _c("div", { staticClass: "text-center pa-4" }, [
                  _c("div", { staticClass: "d-inline-block" }, [
                    _c(
                      "div",
                      { staticClass: "mt-3 mb-3" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-mini",
                            attrs: { block: "", rounded: "" },
                            on: {
                              click: function ($event) {
                                return _vm.$ebus.$emit(
                                  "gotoWebsite",
                                  _vm.order.invoiceUrl
                                )
                              },
                            },
                          },
                          [
                            _vm._v(" Rechnung öffnen "),
                            _c("v-icon", { attrs: { right: "", medium: "" } }, [
                              _vm._v(" mdi-open-in-new "),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.$store.getters.enableStempel &&
            _vm.stempelkarteLoaded &&
            !_vm.orderContainsStempelRedemption
              ? _c("div", { staticClass: "superCenter pt-7" }, [
                  _c(
                    "div",
                    {
                      staticClass: "pointer stempelRahmen",
                      on: {
                        click: function ($event) {
                          return _vm.$ebus.$emit("goto", {
                            name: "Stempelkarte",
                          })
                        },
                      },
                    },
                    [
                      this.order.collectStempel
                        ? _c("div", [
                            _c("h3", [
                              _vm._v("Du hast mit dieser Bestellung "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-decoration-underline text-no-wrap",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.stempelCounter) + " Stempel"
                                  ),
                                ]
                              ),
                              _vm._v(" gesammelt"),
                            ]),
                          ])
                        : _c("StempelAnzahl"),
                      _vm.stempelCounter < 10
                        ? _c("div", {}, [
                            _vm._v(
                              "HINWEIS: Technisch bedingt erfolgt Aktualisierung der Stempelkarte eine Minute nach dem Bestellvorgang. "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            !_vm.$store.getters.inhouse
              ? _c(
                  "div",
                  { staticClass: "pt-7 pb-7 text-center" },
                  [
                    _c("h4", [
                      _vm._v("Teile die App jetzt mit deinen Freunden!"),
                    ]),
                    _c(
                      "v-icon",
                      {
                        staticClass: "mt-5 myAccent pointer",
                        attrs: { "x-large": "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.$ebus.$emit("shareApp")
                          },
                        },
                      },
                      [_vm._v("mdi-share-variant ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("h2", { staticClass: "text-center mt-8" }, [_vm._v("Details")]),
            _c("div", { staticClass: "metaBox text-center" }, [
              _c("div", { staticClass: "d-inline-block text-left" }, [
                _c("table", { staticClass: "maxw myMeta" }, [
                  _c("tr", [
                    _c("td", { staticStyle: { width: "15%" } }, [
                      _vm._v("Bestelldatum:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm._f("dateToString")(_vm.order.createdAt)) +
                          " Uhr"
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c("td", [_vm._v("Gesamtsumme:")]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._f("priceTotal")(_vm.order.paymentInfo.amount)
                        )
                      ),
                    ]),
                  ]),
                  !_vm.$store.getters.isKiosk && !_vm.containsTicket()
                    ? _c("tr", [
                        _c("td", [_vm._v("Bestell-Typ:")]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("displayOrderUsecase")(_vm.order.usecase)
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  !_vm.$store.getters.isKiosk ||
                  _vm.$store.getters.isAndroidKiosk
                    ? _c("tr", [
                        _c("td", [_vm._v("Zahlung:")]),
                        _c("td", [_vm._v(_vm._s(_vm.displayZahlungsart))]),
                      ])
                    : _vm._e(),
                  !_vm.$store.getters.isKiosk
                    ? _c("tr", [
                        _c("td", [_c("div", [_vm._v("Abbuchung:")])]),
                        _c("td", [
                          _vm.order.capturedAt
                            ? _c("span", [
                                _vm._v(
                                  "am " +
                                    _vm._s(
                                      _vm._f("sdd")(_vm.order.capturedAt)
                                    ) +
                                    " Uhr"
                                ),
                              ])
                            : _c("span", [_vm._v("ausstehend")]),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "spacer-15" }),
            _c(
              "div",
              {
                staticClass: "text-center",
                staticStyle: { margin: "10px", padding: "15px 16px" },
              },
              [
                _vm.order.capturedAt
                  ? _c("h3", [
                      _vm._v(
                        "Bezahlt am " +
                          _vm._s(_vm._f("dateToString")(_vm.order.capturedAt))
                      ),
                    ])
                  : _vm._e(),
                _vm.order.state === "Rejected"
                  ? _c("h3", [
                      _vm._v(
                        "Ablehnungsgrund: " + _vm._s(_vm.displayRejectReason)
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _c("div", { staticClass: "spacer-15" }),
            !_vm.$store.getters.isKiosk
              ? _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _vm._v("   "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "okBtn btn-df",
                        attrs: { rounded: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.gotoAllOrders.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(" Alle Bestellungen ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "spacer-25" }),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "btn-df okBtn",
                    attrs: { rounded: "" },
                    nativeOn: {
                      "&click": function ($event) {
                        return _vm.clickNewOrder.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm.$store.getters.isKiosk
                      ? _c("span", [_vm._v("Neue Bestellung starten")])
                      : _c("span", [_vm._v("Zurück")]),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "spacer-25" }),
          ])
        : _vm._e(),
      _vm.ready
        ? _c("div", [
            _vm.showOk
              ? _c("div", { staticClass: "yellowHinweis showOk" }, [
                  _c("div", { staticClass: "superCenter" }, [
                    _c("div", { staticClass: "text-center" }, [
                      _c("h2", [_vm._v("Abholbereit!")]),
                      _vm.order.table
                        ? _c(
                            "div",
                            {
                              staticClass: "pa-6",
                              staticStyle: { "font-size": "1.4em" },
                            },
                            [
                              _vm._v(
                                "Bestell-Nr. " + _vm._s(_vm.order.orderNumber)
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "pa-6",
                              staticStyle: { "font-size": "1.4em" },
                            },
                            [
                              _vm._v(
                                "Bestell-Nr. " + _vm._s(_vm.order.orderNumber)
                              ),
                            ]
                          ),
                      _c(
                        "div",
                        {
                          staticClass: "mt-6 ok pointer",
                          on: {
                            "&click": function ($event) {
                              return _vm.ok.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(" >> OK << ")]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.showGetraenkeOk
              ? _c("div", { staticClass: "yellowHinweis showOk" }, [
                  _c("div", { staticClass: "superCenter" }, [
                    _c("div", { staticClass: "text-center" }, [
                      _c("h2", [_vm._v("Getränke Abholbereit!")]),
                      _vm.order.table
                        ? _c(
                            "div",
                            {
                              staticClass: "pa-6",
                              staticStyle: { "font-size": "1.4em" },
                            },
                            [
                              _vm._v(
                                "Bestell-Nr. " + _vm._s(_vm.order.orderNumber)
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "pa-6",
                              staticStyle: { "font-size": "1.4em" },
                            },
                            [
                              _vm._v(
                                "Bestell-Nr. " + _vm._s(_vm.order.orderNumber)
                              ),
                            ]
                          ),
                      _c(
                        "div",
                        {
                          staticClass: "mt-6 ok pointer",
                          on: {
                            "&click": function ($event) {
                              return _vm.ok.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(" >> OK << ")]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.$store.state.enableSelfServiceExtras
              ? _c("div", [_vm._m(0), _vm._m(1)])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("audio", { attrs: { id: "a-order", loop: "" } }, [
      _c("source", {
        attrs: {
          id: "s-order",
          src: "takeawayOrder2x.mp3",
          type: "audio/mpeg",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("audio", { attrs: { id: "a-drinks", loop: "" } }, [
      _c("source", {
        attrs: {
          id: "s-drinks",
          src: "takeawayDrinks2x.mp3",
          type: "audio/mpeg",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }